module.exports = __webpack_public_path__ + "img/hand-heart.77a0ff86.svg";